import React, { useEffect } from 'react'
import { Button } from 'components'
import useApp from 'hooks/useApp'

const CertiNone = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding center-cont">
				<i className="icon icon_error_circle" />
				<h3 className="intro-tit mt_30">등록하신 인증서가 없습니다.</h3>
				<p className="intro-sub-tit mt_10">하단의 인증서가져오기 버튼을 클릭하시거나<br />
					<span style={{ fontWeight: 500 }}>인증센터 &gt; 인증서 가져오기 메뉴</span>를 클릭하여<br />
					인증서를 복사 후 이용하실 수 있습니다.</p>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">인증서 가져오기</Button>
			</div>
		</div>
	)
}

export default CertiNone
